module.exports = __webpack_public_path__ + "img/dz.4be984a3.svg";